var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#DFE7F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2351_8463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 10H12.8333C11.8222 10 11 10.8222 11 11.8333V12.2917C11 12.6978 11.1774 13.0635 11.4583 13.3156V18.7083C11.4583 19.972 12.4864 21 13.75 21H15.125C15.378 21 15.5833 20.7947 15.5833 20.5417C15.5833 20.2887 15.378 20.0833 15.125 20.0833H13.75C12.9919 20.0833 12.375 19.4664 12.375 18.7083V13.6667H20.625V14.125C20.625 14.378 20.8303 14.5833 21.0833 14.5833C21.3363 14.5833 21.5417 14.378 21.5417 14.125V13.3156C21.8226 13.0635 22 12.6982 22 12.2917V11.8333C22 10.8222 21.1778 10 20.1667 10ZM12.375 12.75C12.1225 12.75 11.9167 12.5442 11.9167 12.2917V11.8333C11.9167 11.3278 12.3278 10.9167 12.8333 10.9167H20.1667C20.6722 10.9167 21.0833 11.3278 21.0833 11.8333V12.2917C21.0833 12.5442 20.8775 12.75 20.625 12.75H12.375ZM18.7917 14.5833C17.0225 14.5833 15.5833 16.0225 15.5833 17.7917C15.5833 19.5608 17.0225 21 18.7917 21C20.5608 21 22 19.5608 22 17.7917C22 16.0225 20.5608 14.5833 18.7917 14.5833ZM18.7917 20.0833C17.528 20.0833 16.5 19.0553 16.5 17.7917C16.5 16.528 17.528 15.5 18.7917 15.5C20.0553 15.5 21.0833 16.528 21.0833 17.7917C21.0833 19.0553 20.0553 20.0833 18.7917 20.0833Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3335,
    y: 16.4165,
    width: 0.55,
    height: 1.65,
    rx: 0.275,
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3335,
    y: 18.6167,
    width: 0.55,
    height: 0.55,
    rx: 0.275,
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2351_8463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(11 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.7590bfc1c5c4c5d255b006cd3aa98647.svg";
export { ForwardRef as ReactComponent };